import { render, staticRenderFns } from "./star-review.vue?vue&type=template&id=d1ad22ea"
import script from "./star-review.vue?vue&type=script&lang=js"
export * from "./star-review.vue?vue&type=script&lang=js"
import style0 from "./star-review.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports